import { render, staticRenderFns } from "./VoucherCardsList.vue?vue&type=template&id=0073b3f9&"
import script from "./VoucherCardsList.vue?vue&type=script&lang=js&"
export * from "./VoucherCardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports